/*
 *
 * DisputeShopPickerPopup
 *
 * Container that wraps ShopPickerPopup with dispute-specific state and actions.
 * Reads selectorDisputeGroups (1 group, flat shops) instead of selectorGroups,
 * and dispatches doSetDisputeShopSelection on apply instead of doSetShopSelection.
 *
 * @version 1.0.0
 * @author a.mancuso
 * @since 13-Apr-2026
 */

import { connect } from 'react-redux'
import ShopPickerPopup from 'Components/ShopPickerPopup/ShopPickerPopup'
import { nullSafe } from 'Utility/globalMethods'
import {
  doClearShopSelection,
  clearSearchTerm,
  doSetShopSelectionMode,
  doClearShopLocalSelection,
  doSetDisputeShopSelection,
  doSetLocalSelectedTab
} from 'Store/actions/shopPicker'
import { doHidePopup, doShowPopup } from 'Store/actions/popup'

const mapDispatchToProps = dispatch => ({
  setShopSelection: (group, data, selectorGroups) => dispatch(doSetDisputeShopSelection({ group, data, selectorGroups })),
  clearShopSelection: (group, data) => dispatch(doClearShopSelection(group, data)),
  doClosePopup: (type) => dispatch(doHidePopup(type)),
  doShowPopup: (type) => dispatch(doShowPopup(type)),
  clearSearchTerm: (payload) => dispatch(clearSearchTerm(payload)),
  doSetShopSelectionMode: (mode, page) => dispatch(doSetShopSelectionMode(mode, page)),
  doClearShopLocalSelection: (payload) => dispatch(doClearShopLocalSelection(payload)),
  doGetShopList: () => { },
  doSetLocalSelectedTab: (payload) => dispatch(doSetLocalSelectedTab(payload))
})

const mapStateToProps = state => ({
  selectorGroups: nullSafe(() => state.userProfiling.selectorDisputeGroups, []),
  shopSelections: nullSafe(() => state.shopPicker.group, []),
  shopSelectionFromPage: 'dispute-uci',
  shopLocalSelection: nullSafe(() => state.shopPicker.shopLocalSelection, {}),
  searchTerm: nullSafe(() => state.shopPicker.searchTerm, ''),
  localSelectedTab: nullSafe(() => state.shopPicker.localSelectedTab, null)
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  maxSelectableShops: 5985,
  actions: dispatchProps
}))(ShopPickerPopup)
